import React from "react";
export const getForwarderContextById = (forwardersContext) => (id) => forwardersContext[id] || { state: void 0, metrics: [] };
const ForwardersContext = React.createContext({
  forwarders: [],
  forwardersContext: {},
  isLoading: false,
  getForwarderContext: () => void 0
});
export default ForwardersContext;
